import { Paths, ProjectPathParams } from '../../../app/router/app.router';
import { TeamMembersListActions } from './hooks/use-team-members-list.hook';
import { InviteTeamMemberModal } from './modals/invite-team-member-modal/invite-team-member-modal.component';
import { Snackbar } from '../../../ui/components/pure/snackbar/snackbar.component';

export function TeamMembersListActionsObserver({
  params,
  actions
}: {
  params: ProjectPathParams<Paths.team>;
  actions: ReturnType<any>;
}) {
  switch (actions.currentAction) {
    case TeamMembersListActions.INVITE_TEAM_MEMBER:
      return (
        <InviteTeamMemberModal
          projectID={params.projectID}
          onAbort={() => actions.setAction(null)}
          onSuccess={() => actions.setAction(TeamMembersListActions.INVITE_TEAM_MEMBER_SUCCESS)}
        />
      );
    case TeamMembersListActions.INVITE_TEAM_MEMBER_SUCCESS:
      return (
        <Snackbar onClose={() => actions.setAction(null)} severity={'success'}>
          The invitation has been sent
        </Snackbar>
      );
    default:
      return null;
  }
}
